export const COMMON_CHECKBOX_TEST_ID = 'common-checkbox';
export const COMMON_CHECKBOX_INPUT_TEST_ID = 'common-checkbox__input';
